/* eslint-disable @typescript-eslint/no-var-requires */
import React, { useEffect } from 'react';
import { usePlayFlag } from './../../components/topicScroll';

import './animation029.less';
import ImgPoint from '../../../../../assets/animation_point.gif';

interface IAnimation029Item {
  text: string;
}

interface IAnimation029Props {
  items: IAnimation029Item[];
  className?: string;
  onCompleted?: () => void;
}

const bgTemplate = [
  '#1AB6B6',
  '#DD936F',
  '#F9A35B',
  '#597EF7',
  '#EF878D',
  '#33A5C9',
];
const getBG = (feed: number) => bgTemplate[feed % bgTemplate.length];

const Animation029: React.FunctionComponent<IAnimation029Props> = ({
  items,
  className,
  onCompleted,
}) => {
  const crrRef = React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);
  const startPlay = (next = 2) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1200);
    } else {
      onCompleted && onCompleted();
    }
  };

  useEffect(() => {
    if (playFlag && play <= 1) {
      startPlay();
    }
  }, [playFlag]);

  const clickToPlay = () => {
    if (play <= 1) {
      startPlay();
    }
  };

  return (
    <div ref={crrRef} className={`animation029 component ${className || ''}`}>
      {items.map((itm: IAnimation029Item, idx: number) => (
        <div
          onClick={() => clickToPlay()}
          key={idx}
          className={`animation029-item r${idx + 1} animation ${
            play >= idx + 1 ? 'fade-in' : ''
          }`}
        >
          <img
            className="click-point"
            onClick={() => clickToPlay()}
            style={{
              display: play <= 1 ? 'block' : 'none',
            }}
            src={ImgPoint}
            alt=""
          />
          <div
            style={{
              backgroundColor: getBG(idx),
            }}
            className="text"
            dangerouslySetInnerHTML={{ __html: itm.text }}
          />
        </div>
      ))}
    </div>
  );
};

export default Animation029;
